import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./Toast.module.scss"
import { useToastContext } from "./useToastContext"
import {
  CheckMarkFillIcon,
  ExclamationFillIcon,
} from "src/icons"

export type Props = ComponentPropsWithoutRef<"svg">

export const ToastIcon = forwardRef<SVGElement, Props>(
  function ToastIcon(props: Props, ref: Ref<SVGElement>) {
    const className = classNames(
      props.className,
      styles.toastIcon,
    )

    const { stylePreset } = useToastContext()

    const allProps = {
      ...props,
      className,
      ref,
    }

    return stylePreset === "success" ? <CheckMarkFillIcon {...allProps} /> : <ExclamationFillIcon {...allProps} />
  },
)
